export default __webpack_public_path__ + "static/media/connectlogo.04fd5d81.svg";